import { aspenApi as api, autoInvestList } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import type { IInvestmentIResponse, IReqAutoProducts } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";

/**
 * 获取自动投资产品列表。
 * @param {IReqAutoProducts} params - 获取自动投资产品所需的参数。
 */
export const useFetchAutoInvestList = (params: IReqAutoProducts) => {
  const apiPath = api.savings.autoInvest.products;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<IInvestmentIResponse>(queryKey);

  const { error, data, isLoading, refetch, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    placeholderData: cacheData,
    queryFn: () => {
      return autoInvestList(params).then(res => {
        if (res?.code == "0") {
          return res.data;
        }
      });
    },
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading };
};
